export default function DeviceStatus({ device }) {
  return (
    <div style={{ marginBottom: 20 }}>
      Device:{" "}
      <strong style={{ color: device ? "green" : "red" }}>
        {device || "Detecting..."}
      </strong>
    </div>
  );
}